"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const FilterBoxLabel = (props) => {
    const { children = null, primary, secondary, badge, active } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Box_1.default, { sx: { textAlign: "left", textTransform: "initial" } },
            react_1.default.createElement(Typography_1.default, { variant: active && !badge ? "caption" : "body1", sx: theme => Object.assign({
                    color: active ? theme.palette.common.white : theme.palette.text.primary,
                }, !active && { fontSize: 16 }, badge && { lineHeight: 1 }), component: "div" }, primary ? primary : children),
            active && !badge && (react_1.default.createElement(Typography_1.default, { variant: "body1", sx: {
                    color: theme => theme.palette.common.white,
                    fontSize: 16,
                    lineHeight: 1
                } }, secondary))),
        badge && (react_1.default.createElement(Box_1.default, { sx: theme => ({
                alignItems: "center",
                backgroundColor: theme.palette.common.white,
                color: theme.palette.text.primary,
                borderRadius: 3,
                display: "inline-flex",
                height: 24,
                justifyContent: "center",
                ml: 1,
                width: 24,
            }) }, badge))));
};
exports.default = FilterBoxLabel;
